import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2 } from '@blueprint/ui';

export const Container = styled('div')(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['16px']};
    `
);

export const Heading = styled(Heading2)(
    ({ theme: { spacing } }) => `
    margin-bottom: ${spacing['16px']};
`
);
